module.exports = __webpack_public_path__ + "./YouhuaPhoto_f043146c114b3c96eb233dd4ec3b7623.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2021/YouhuaPhoto.png
// module id = 545
// module chunks = 0